<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>
<script>
export default {
    name: 'app',
     provide () {    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。                                             
         return {
             reload: this.reload                                              
         }
     },
     data() {
         return{
             isRouterAlive: true  //控制视图是否显示的变量
         }
     },
     beforeCreate() {
       document.title = '深圳市极智数字科技有限公司-建筑行业数字化应用服务商'
     },
     created() { 
      if (this.isMobile()) {
        console.log('这是移动设备');
        this.$router.push({name:'phoneEntry'})
      } else {
        console.log('这是PC设备');
        this.$router.push({name:'App'})
      }
    },
     methods: {
         reload () {
             this.isRouterAlive = false;  //先关闭，
             this.$nextTick(function () {
                 this.isRouterAlive = true; //再打开
             }) 
         },
         isMobile() {
          const userAgent = navigator.userAgent || navigator.vendor || window.opera;
          
          // 正则表达式匹配移动设备
          const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
          
          return mobileRegex.test(userAgent);
        }
     }
}
</script>
<style lang="less">
  * {
    padding: 0;
    margin: 0;
    list-style: none;
    // font-style: '微软雅黑';
  }
  html,body,#app {
    height: 100%;
  }
</style>
